import { get, post } from '@fable/api'
import {
  GenerateSummaryResponse,
  SendSummaryFeedbackPayload,
  SendSummaryFeedbackResponse,
} from '../types'

export const generateSummary = async ({
  userId,
  statsId,
}: {
  userId: string
  statsId: string
}) => {
  const res = await get(`users/${userId}/stats/${statsId}/generate_summary/`)
  return res as GenerateSummaryResponse
}

export const sendSummaryFeedback = async ({
  userId,
  statsId,
  data,
}: {
  userId: string
  statsId: string
  data: SendSummaryFeedbackPayload
}) => {
  const res = await post(
    `users/${userId}/stats/${statsId}/send_summary_feedback/`,
    data
  )
  return res as SendSummaryFeedbackResponse
}

export const updateStatsReaderSummaryOptIn = async ({
  userId,
  optIn,
}: {
  userId: string
  optIn: boolean
}) => await post(`users/${userId}/stats/summary_opt_in/`, { opt_in: optIn })
